import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=6db1aed4&"
import script from "./NoticeModal.vue?vue&type=script&lang=js&"
export * from "./NoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports